import { DataSource } from '@angular/cdk/collections';
import { Component, Inject } from '@angular/core';
import { TechTableModule } from '@tech/components/tech-table';
import { TechIconModule } from '@tech/components/tech-icon';
import { TechButtonModule } from '@tech/components/tech-button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { TechLoaderModule } from '@tech/components/tech-loader';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'permanent-table',
  standalone: true,
  imports: [
    TechTableModule,
    TechLoaderModule,
    CommonModule,
    TechIconModule,
    TechButtonModule,
  ],
  templateUrl: './permanent-table.component.html',
  styleUrl: './permanent-table.component.scss',
})
export class PermanentTableComponent<T> {
  dataSource: DataSource<T>;
  displayColumns: string[] = [];
  loading$!: Observable<boolean>;
  callback: Function;

  constructor(
    public dialogRef: MatDialogRef<PermanentTableComponent<T>>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      receipts: DataSource<T>;
      display: string[];
      loading$: Observable<boolean>;
      callback: () => {};
    }
  ) {
    this.dataSource = data.receipts;
    this.displayColumns = data.display;
    this.loading$ = data.loading$;
    this.callback = data.callback;
  }

  close(): void {
    this.dialogRef.close();
  }
}
